/// Where a "home" exit from a shared surface (dev blog, Tower Log)
/// should land. Those surfaces are reachable two ways: from inside
/// the game SPA (TowerHome buttons), and directly by URL from the
/// static landing page, FIAM banners, and reply-notification emails.
/// A player who came from the game goes back to the game's home
/// screen; a visitor who landed directly belongs on the site's
/// front door, which is a static page outside the SPA (so callers
/// must do a full navigation, not pushState, when this returns '/').
export function exitDestination(enteredInApp: boolean): '/play' | '/' {
  return enteredInApp ? '/play' : '/'
}
